import { faSave } from "@fortawesome/free-regular-svg-icons";
import {
  faCheck,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

/** A pretty save button for forms.
 * Two types: "save" or "submit"
 */
export function SaveButton({
  onClick,
  type,
  formNoun,
  disabled,
  withSpinner = true,
  disabledText,
  children,
  dataTestId,
}) {
  return (
    <button
      id="submitNoteButton"
      className="border-2 shadow-md border-brand rounded-full w-44 py-2 text-lg font-semibold text-white bg-brand hover:bg-indigo-600 disabled:bg-disabled disabled:border-disabled max-w-96 text-center my-2 transition-all focus:outline-hidden"
      onClick={onClick}
      disabled={disabled}
      data-testid={dataTestId}
    >
      {disabled ? (
        <>
          {withSpinner ? (
            <FontAwesomeIcon
              icon={faSpinner}
              color="white"
              className="animate-spin mr-1"
            />
          ) : null}
          {disabledText ? disabledText : null}
        </>
      ) : (
        <>
          {children ? (
            children
          ) : (
            <>
              <FontAwesomeIcon
                icon={type === "save" ? faSave : faCheck}
              />{" "}
              {type === "save" ? "Save " : "Submit "} {formNoun}{" "}
            </>
          )}
        </>
      )}
    </button>
  );
}
